/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getRequirement = /* GraphQL */ `
  query GetRequirement($id: ID!) {
    getRequirement(id: $id) {
      id
      formulaId
      nep
      userId
      details
      name
      orders {
        items {
          id
          RequirementId
          userId
          totalHT
          products
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listRequirements = /* GraphQL */ `
  query ListRequirements(
    $filter: ModelRequirementFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRequirements(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        formulaId
        nep
        userId
        details
        name
        orders {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncRequirements = /* GraphQL */ `
  query SyncRequirements(
    $filter: ModelRequirementFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncRequirements(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        formulaId
        nep
        userId
        details
        name
        orders {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getLetters = /* GraphQL */ `
  query GetLetters($id: ID!) {
    getLetters(id: $id) {
      id
      code
      condition
      LettersSubThemes {
        items {
          id
          subthemeID
          lettersID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listLetters = /* GraphQL */ `
  query ListLetters(
    $filter: ModelLettersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLetters(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        code
        condition
        LettersSubThemes {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncLetters = /* GraphQL */ `
  query SyncLetters(
    $filter: ModelLettersFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncLetters(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        code
        condition
        LettersSubThemes {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getTheme = /* GraphQL */ `
  query GetTheme($id: ID!) {
    getTheme(id: $id) {
      id
      ref
      name
      Languages {
        items {
          id
          code
          label
          themeID
          subthemeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listThemes = /* GraphQL */ `
  query ListThemes(
    $filter: ModelThemeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listThemes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        ref
        name
        Languages {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncThemes = /* GraphQL */ `
  query SyncThemes(
    $filter: ModelThemeFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncThemes(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        ref
        name
        Languages {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getSubTheme = /* GraphQL */ `
  query GetSubTheme($id: ID!) {
    getSubTheme(id: $id) {
      id
      ref
      title
      isSub
      parentId
      Languages {
        items {
          id
          code
          label
          themeID
          subthemeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      letters {
        items {
          id
          subthemeID
          lettersID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listSubThemes = /* GraphQL */ `
  query ListSubThemes(
    $filter: ModelSubThemeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSubThemes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        ref
        title
        isSub
        parentId
        Languages {
          nextToken
          startedAt
        }
        letters {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncSubThemes = /* GraphQL */ `
  query SyncSubThemes(
    $filter: ModelSubThemeFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncSubThemes(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        ref
        title
        isSub
        parentId
        Languages {
          nextToken
          startedAt
        }
        letters {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getLanguage = /* GraphQL */ `
  query GetLanguage($id: ID!) {
    getLanguage(id: $id) {
      id
      code
      label
      themeID
      subthemeID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listLanguages = /* GraphQL */ `
  query ListLanguages(
    $filter: ModelLanguageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLanguages(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        code
        label
        themeID
        subthemeID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncLanguages = /* GraphQL */ `
  query SyncLanguages(
    $filter: ModelLanguageFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncLanguages(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        code
        label
        themeID
        subthemeID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getFormula = /* GraphQL */ `
  query GetFormula($id: ID!) {
    getFormula(id: $id) {
      id
      userId
      name
      ingredients
      requirements {
        items {
          id
          formulaId
          nep
          userId
          details
          name
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listFormulas = /* GraphQL */ `
  query ListFormulas(
    $filter: ModelFormulaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFormulas(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userId
        name
        ingredients
        requirements {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncFormulas = /* GraphQL */ `
  query SyncFormulas(
    $filter: ModelFormulaFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncFormulas(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        userId
        name
        ingredients
        requirements {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getOrder = /* GraphQL */ `
  query GetOrder($id: ID!) {
    getOrder(id: $id) {
      id
      RequirementId
      userId
      totalHT
      products
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listOrders = /* GraphQL */ `
  query ListOrders(
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrders(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        RequirementId
        userId
        totalHT
        products
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncOrders = /* GraphQL */ `
  query SyncOrders(
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncOrders(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        RequirementId
        userId
        totalHT
        products
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getFlexibleFeatures = /* GraphQL */ `
  query GetFlexibleFeatures($id: ID!) {
    getFlexibleFeatures(id: $id) {
      id
      title
      atex
      continuite_electrique
      fda
      wras
      bfr
      ce_1935_2004
      ce_2023_2006
      simulantA
      simulantB
      simulantC
      simulantD1
      simulantD2
      simulantE
      usp_class_6
      agrement_bnic
      alcool95
      eau_chaude
      vapeur
      acide_nitrique
      acide_phosphorique
      composes_chlores
      hydroxyde_sodium
      peroxyde_hydrogene
      acide_paracetique
      pression_service
      depression
      souplesse
      legerete
      accepte_ecrasement_accidentel
      temperatureMin
      temperatureMax
      productsCodes
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listFlexibleFeatures = /* GraphQL */ `
  query ListFlexibleFeatures(
    $filter: ModelFlexibleFeaturesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFlexibleFeatures(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        atex
        continuite_electrique
        fda
        wras
        bfr
        ce_1935_2004
        ce_2023_2006
        simulantA
        simulantB
        simulantC
        simulantD1
        simulantD2
        simulantE
        usp_class_6
        agrement_bnic
        alcool95
        eau_chaude
        vapeur
        acide_nitrique
        acide_phosphorique
        composes_chlores
        hydroxyde_sodium
        peroxyde_hydrogene
        acide_paracetique
        pression_service
        depression
        souplesse
        legerete
        accepte_ecrasement_accidentel
        temperatureMin
        temperatureMax
        productsCodes
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncFlexibleFeatures = /* GraphQL */ `
  query SyncFlexibleFeatures(
    $filter: ModelFlexibleFeaturesFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncFlexibleFeatures(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        title
        atex
        continuite_electrique
        fda
        wras
        bfr
        ce_1935_2004
        ce_2023_2006
        simulantA
        simulantB
        simulantC
        simulantD1
        simulantD2
        simulantE
        usp_class_6
        agrement_bnic
        alcool95
        eau_chaude
        vapeur
        acide_nitrique
        acide_phosphorique
        composes_chlores
        hydroxyde_sodium
        peroxyde_hydrogene
        acide_paracetique
        pression_service
        depression
        souplesse
        legerete
        accepte_ecrasement_accidentel
        temperatureMin
        temperatureMax
        productsCodes
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getWordpress = /* GraphQL */ `
  query GetWordpress($id: ID!) {
    getWordpress(id: $id) {
      id
      userId
      wordpressUserId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listWordpresses = /* GraphQL */ `
  query ListWordpresses(
    $filter: ModelWordpressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWordpresses(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userId
        wordpressUserId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncWordpresses = /* GraphQL */ `
  query SyncWordpresses(
    $filter: ModelWordpressFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncWordpresses(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        userId
        wordpressUserId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
